import { FluxStandardAction } from "__utils/type";
import * as Actions from "../../constants/actions";

export const fetchCartDetails = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_CART_DETAILS,
    } 
    
};

export const fetchCartDetailsSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_CART_DETAILS_SUCCESS,
        payload: {
            data: data
        }
    }
};

export const fetchCartDetailsError = (error: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_CART_DETAILS_ERROR,
        payload: {
            data: error
        }
    }
};